import type { Page } from '@repo/types';

export function useBrowseAreas() {
  /**
   * Sorts an array of pages by their property count in descending order.
   */
  const sortAreas = (areas: Page[]): Page[] => {
    return [...areas].sort((a, b) => (b.stats?.count || 0) - (a.stats?.count || 0));
  };

  /**
   * Returns the background image URL for a featured area card.
   * Only the first 4 cards are eligible for featuring.
   */
  const getBgImage = (child: Page, index: number): string | null => {
    return index < 4 ? (child.data?.thumbnail?.source || child.data?.imageUrls?.[0] || null) : null;
  };

  return {
    sortAreas,
    getBgImage,
  };
}
